import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Button from 'components/Button';
import Icon from 'components/Icon';

import Header from 'modules/Header';

import useFreshchatWidget from 'utils/useFreshchatWidget';

const AddProject = lazy(() => import('modules/Projects/container/AddProject'));
const ShareProject = lazy(() =>
  import('modules/Projects/container/ShareProject'),
);
const TeamDisabled = lazy(() => import('modules/Team/components/TeamDisabled'));

const showPoweredByOn = [
  '/projects',
  '/projects/archived',
  '/projects/web',
  '/projects/illustration',
  '/profile',
  '/project/:projectID',
  '/project/:projectID/:pageID',
  '/project/:projectID/archived',
  '/billing',
  '/upgrade',
  '/team',
  '/team/:teamID',
];

const DashboardLayout = ({ children, match }) => {
  const { openFreshChat } = useFreshchatWidget();

  const { user, teams, addProjectModal, shareProjectModal } = useSelector(
    ({ user: userObj, project, team }) => ({
      user: userObj.user,
      addProjectModal: project.addProjectModal,
      shareProjectModal: project.shareProjectModal,
      teams: team.teams,
    }),
  );

  const location = useLocation();

  const showShareModal =
    shareProjectModal &&
    (match.path.startsWith('/projects') ||
      match.path === '/project/:projectID' ||
      match.path === '/project/:projectID/archived');

  const showTeamDisabled =
    teams?.length &&
    teams[0].isDisabled === true &&
    teams[0].name &&
    !['/upgrade'].includes(location.pathname);

  return user && user.uid ? (
    <>
      <Header match={match} />
      {!!showTeamDisabled && (
        <Suspense fallback={null}>
          <TeamDisabled showUpgrade={teams[0].owner === user.uid} />
        </Suspense>
      )}
      {children}
      {match.path.startsWith('/projects') && (
        <Suspense fallback={null}>
          <AddProject show={addProjectModal} />
        </Suspense>
      )}
      {showShareModal && (
        <Suspense fallback={null}>
          <ShareProject show={shareProjectModal} />
        </Suspense>
      )}
      {showPoweredByOn.includes(match.path) && (
        <Button
          type="button"
          className="dashboard-contact-us"
          onClick={openFreshChat}>
          <Icon name="love-contact" verticalAlign="middle" />
          <span>Need help?</span>
        </Button>
      )}
    </>
  ) : (
    <></>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  match: PropTypes.object.isRequired,
};

export default DashboardLayout;
